import React, { Component } from 'react'
import { Row, Col, Badge, Button, Table, Form, InputGroup } from 'react-bootstrap';
import './StyleOrder.css';
import { onPrint } from '../../helpers/functionForLicense';
import {
  getQuantity, getDescription, getPacking, getMask, getShipper, getShippingBehalf, getNetWeight,
  getLoadingDate, getPlaceLoading, getShippingPort, getCarrayVessel, getDestination, getGrossWeight,
  getTareWeight, getExportLicense, addCommaInNumber, getEachNetWeight, getEachGrossWeight, convertRiceTypeENToENFull
} from '../../helpers/function';

export default class Order extends Component {
  state = {
    Certificate: null,
    redirect: false 
  }
  convertDeCodeText(text) {
    if (text) {  
      text = text.replace(/_S/g, ' ')
      text = text.replace(/_D/g, '.')
      text = text.replace(/_P/g, '%') 
      text = text.replace(/_B/g, '/')
      if (text === 'blank') {
        return null
      } else {
        return text
      }
    }
  }

  renderCompany(companyObj, allCompany) {
    let viewAllCompany = allCompany
    let outputCompany = null
    Object.values(viewAllCompany).map((companyData) => {
      if (companyData['companyNameTH'].replace(/\s/g, '').trim() == companyObj.replace(/\s/g, '').trim()) {
        outputCompany = companyData['companyNameEN']
      }
    })
    if (companyObj == 'ไทยฮาจำกัด') {
      outputCompany = 'THAI HA PUBLIC CO., LTD.'
    } else if (companyObj == 'ไทยฟ้า(2511)จำกัด') {
      outputCompany = 'THAI HUA (2511) CO., LTD.'
    }
    if (outputCompany) {
      return outputCompany
    } else {
      return companyObj
    }
  }
  renderQuantity(paragraph, newHandleData) {
    if (paragraph == '- bags') {
      return `${addCommaInNumber(getNetWeight(newHandleData))}  kgs.nett`
    } else {
      return paragraph
    }
  }
  isInbulk(handleData) {
    // console.log(handleData['PackingType'])
    if (handleData['PackingType'] != 'in  bulk') {
      return `${addCommaInNumber(getEachGrossWeight(handleData))}  kgs.gross  and  ${addCommaInNumber(getEachNetWeight(handleData))}  kgs.nett`
    } else {
      return ''
    }
  }
  componentDidMount() {

    // let newHandleData = this.props.Certificate.description.filter((o)=>{
    //   return o.licenseID == this.props.Certificate['licenseID'] && o.subID == this.props.Certificate['subID']
    // })
    let handleData = this.props.Certificate.description[this.props.desIndex]
    // let handleData = newHandleData[0]
    let CheckWeightSheet = this.props.Certificate
    let allCompany = this.props.allCompany
    let date = new Date()
    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
    let day = date.getDate()
    let month = months[date.getMonth()]
    let year = date.getFullYear()

    this.setState({
      Certificate: {
        ...this.props.Certificate,
        description: {
          ...this.props.Certificate.description,
          [this.props.desIndex]: {
            ...this.props.Certificate.description[this.props.desIndex],
            'No': '0',
            'bagQuantity': this.renderQuantity(getQuantity(handleData), handleData),
            'riceTypeID': convertRiceTypeENToENFull(getDescription(handleData)),
            'PackingType1': getPacking(handleData),
            'PackingType11': '-',
            'PackingType12': '-',
            'PackingType2': this.isInbulk(handleData),
            'logo': getMask(handleData),
            'ShipperBehalf': 'xxxxxx',
            'destinationCity': this.changeToUpper(getDestination(handleData)),
            'vehicleName': getCarrayVessel(handleData),
            'TotalGross': getGrossWeight(handleData),
            'TotalTare': getTareWeight(handleData),
            'TotalNett': getNetWeight(handleData),
            'License': getExportLicense(handleData),
          }
        },
        'currentDate': `${this.props.currentDate}`,
        'shippingDate': getLoadingDate(CheckWeightSheet), 
        'godown': getPlaceLoading(CheckWeightSheet,this.props.survey),
        'shippingPort': "Bangkok",
        'Quality1': "We  inspected  the  rice  at  time  and  place  of  loading  and  found  that  the  quality  of  rice",
        "Quality2": `conformed  with  Thai  Rice  Standards “${convertRiceTypeENToENFull(getDescription(handleData))}”`,
        "Weight": `On  the  basis  of  random  weight  testing,  we  certify  the  loaded  weight  ${getQuantity(handleData)}  to  be:`,
        'title1': 'WE  HEREBY  CERTIFY  that  we  inspected  the  following  rice  shipment:-',
        'companyEN': this.changeCompany(this.renderCompany(CheckWeightSheet['companyID'], allCompany),allCompany)
      },
    })
  }
  renderLicenseID(licenseID) {
    return <a href="javascript:void(0)" onClick={() => { onPrint(licenseID) }}> {licenseID}</a>
  }
  handleDescription(e) {
    let id = e.target.id
    let value = e.target.value
    // console.log(id)
    if (id == 'PackingType1') {
      let handleData = this.props.Certificate.description[this.props.desIndex]
      let quantity = handleData['bagQuantity']?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      let title = ''
      let grossWeight = getGrossWeight(handleData)
      let tarWeight = getTareWeight(handleData)
      if (value.toLowerCase() == 'in  plastic  bags  contained  in  cartons  of'.toLowerCase()) {
        quantity = `${quantity}  cartons`
        title = quantity
      }
      else if (value.toLowerCase() == 'in  plastic  bags  contained  in  tray  of'.toLowerCase()) {
        quantity = `${quantity}  trays`
        title = quantity
      }
      else if (value.toLowerCase() == 'Inner  PE  Outer  TRAY'.toLowerCase()) {
        quantity = `${quantity}  kgs.nett`
        title = quantity
      }
      else if (value.toLowerCase() == 'In  Bulk'.toLowerCase()) {
        title = `- bags`
        quantity = `${addCommaInNumber(getNetWeight(handleData))}  kgs.nett`
        grossWeight = '-'
        tarWeight = '-'
      }
      else {
        quantity = `${quantity}  bags`
        title = quantity
      }
      let packing2 = ''
      if (value.toLowerCase() != 'in  bulk'.toLowerCase()) {
        packing2 = `${addCommaInNumber(getEachGrossWeight(handleData))}  kgs.gross  and  ${addCommaInNumber(getEachNetWeight(handleData))}  kgs.nett`
      }
      this.setState({
        ...this.state,
        Certificate: {
          ...this.state.Certificate,
          description: {
            ...this.state.Certificate.description,
            [this.props.desIndex]: {
              ...this.state.Certificate.description[this.props.desIndex],
              [id]: value,
              ['bagQuantity']: quantity,
              ['PackingType2']: packing2,
              ['TotalGross']: grossWeight,
              ['TotalTare']: tarWeight,
              ['TotalNett']: getNetWeight(handleData),
            }
          },
          ['Weight']: `On  the  basis  of  random  weight  testing,  we  certify  the  loaded  weight  ${title}  to  be:`
        }
      })
    } else {
      this.setState({
        ...this.state,
        Certificate: { 
          ...this.state.Certificate,
          description: {
            ...this.state.Certificate.description,
            [this.props.desIndex]: {
              ...this.state.Certificate.description[this.props.desIndex],
              [id]: value
            }
          }
        }
      })
    }
  }
  handleCertificate(e) {
    let id = e.target.id
    let value = e.target.value
    this.setState({
      ...this.state,
      Certificate: {
        ...this.state.Certificate,
        [id]: value
      }
    })
  }

  changeToUpper(a){
    let company = a.toLowerCase()
    company = company.split(" ")
    let temp = ''
    // console.log(company)
    company.map((e,idx) => {
      if(e.trim() == 'fz'){
        temp += 'FZ  '
      }
      else if(e.trim() == 'chachoengsao'){
        temp += 'Chachoengsao, '
      }
      else if (e != 'of' && e.indexOf('(') == -1) {
        temp += `${(e.charAt(0).toUpperCase() + e.slice(1))}  `
      }
      else if (e.indexOf('(') != -1) {
        // console.log( e.charAt(1))
        temp += `${(e.charAt(0) + e.charAt(1).toUpperCase() + e.slice(2))}  `
      }
      else {
        temp += `${e}  `
      }
    })
    let strSplit = temp.split('')
    temp = ''
    strSplit.map((e,idx)=>{
      // console.log(e)
      if(strSplit[idx - 1 ] == '.'){
        temp += `${e.toUpperCase()}`
      }else{
        temp += `${e}`
      }
    })
    return temp
  }

  changeCompany(a,allCompany) {
    try {
      let fullCompany = a.toUpperCase()
      let companyLength = Object.values(allCompany).filter((o)=>{ return o.companyNameEN == fullCompany})
      if(!companyLength[0]['companyNameENFull']){
        let company = a.toLowerCase()
        company = company.split(" ")
        let temp = ''
        // console.log(company)
        company.map((e,idx) => {
          if(e.trim() == 'fz'){
            temp += 'FZ  '
          }
          else if(e.trim() == 'chachoengsao'){
            temp += 'Chachoengsao, '
          }
          else if (e != 'of' && e.indexOf('(') == -1) {
            temp += `${(e.charAt(0).toUpperCase() + e.slice(1))}  `
          }
          else if (e.indexOf('(') != -1) {
            // console.log( e.charAt(1))
            temp += `${(e.charAt(0) + e.charAt(1).toUpperCase() + e.slice(2))}  `
          }
          else {
            temp += `${e}  `
          }
        })
        let strSplit = temp.split('')
        temp = ''
        strSplit.map((e,idx)=>{
          // console.log(e)
          if(strSplit[idx - 1 ] == '.'){
            temp += `${e.toUpperCase()}`
          }else{
            temp += `${e}`
          }
        })
        return temp
      }else{
        return companyLength[0]['companyNameENFull']
      }
    } catch (error) {
      return ''
    }
  }
  getDefaultValue(value){
    if(value){
      if(value.toLowerCase() == 'others'){
        return null
      }else{
        return value
      }  
    }else{
      return value
    }
  }
  renderPackingType(PackingType,func,desIndex) {
    // console.log(PackingType)
    // if (PackingType == 'Others' || PackingType == 'in new single gunny bags of'
    //   || PackingType == 'in new double polypropylene bags of' || PackingType == 'in new double gunny bags of'
    //   || PackingType == 'in new triple polypropylene bags of' || PackingType == 'in double bags (inner : foil and outer : polypropylene) of'
    //   || PackingType == 'in polypropylene with handle bags of' || PackingType == 'in double bags (inner : plastic and outer : handle polypropylene) of'
    //   || PackingType == 'in new single jumbo polypropylene bags of' || PackingType == 'in plastic bottle contained in cartons of'
    //   || PackingType == 'in brown paper bags 3 layers'
    // ) {
    if(!func){
      return (<div>
        {/* <Form.Control as="select" onChange={(e) => { this.handleDescription(e) }} id="PackingType1" defaultValue={PackingType} list="brow"> */}
          <input className='form-control' onChange={(e) => { this.handleDescription(e) }} id="PackingType1" defaultValue={this.getDefaultValue(PackingType)} list="brow" />
        {/* </Form.Control> */}
        <datalist id="brow">
          <option value="">โปรดเลือก</option>
          <option label='' value="in  new  single  polypropylene  bags  of">in  new  single  polypropylene  bags  of</option>
          <option label='' value="in  new  single  jumbo  polypropylene  bags  of">in  new  single  jumbo  polypropylene  bags  of</option>
          <option label='' value="in  polypropylene  bags  contained  in  polypropylene  of">in  polypropylene  bags  contained  in  polypropylene  of</option>
          <option label='' value="in  double  bags  (inner  :  plastic  and  outer  :  polypropylene)  of">in  double  bags (inner  :  plastic  and  outer  :  polypropylene)  of</option>
          <option label='' value="in  plastic  bags  contained  in  cartons  of">in  plastic  bags  contained  in  cartons  of</option>
          <option label='' value="in  bulk">in  bulk</option>

          <option label='' value="in  new  single  gunny  bags  of">in  new  single  gunny  bags  of</option>
          <option label='' value="in  new  double  polypropylene  bags  of">in  new  double  polypropylene  bags  of</option>
          <option label='' value="in  new  double  gunny  bags  of">in  new  double  gunny  bags  of</option>
          <option label='' value="in  new  triple  polypropylene  bags  of">in  new  triple  polypropylene  bags  of</option>
          <option label='' value="in  polypropylene  with  handle  bags  of">in  polypropylene  with  handle  bags  of</option>
          <option label='' value="in  double  bags  (inner  :  foil  and  outer  :  polypropylene)  of">in  double  bags  (inner  :  foil  and  outer  :  polypropylene) of</option>
          <option label='' value="in  double  bags  (inner  :  plastic  and  outer  :  handle  polypropylene)  of">in  double  bags  (inner  :  plastic  and  outer  :  handle  polypropylene)  of</option>
          <option label='' value="in  plastic  bottle  contained  in  cartons  of">in  plastic  bottle  contained  in  cartons  of</option>
          <option label='' value="in  plastic  bags  contained  in  tray  of">in  plastic  bags  contained  in  tray  of</option>
          <option label='' value="in  double  bags  (inner  :  plastic  and  outer  :  gunny)  of">in  double  bags  (inner  :  plastic  and  outer  :  gunny)  of</option>
          <option label='' value="in  new  single  polyethylene  bags  of">in  new  single  polyethylene  bags  of</option>
          <option label='' value="in  double  bags  (inner  :  plastic  and  outer  :  plastic)  of">in  double  bags  (inner  :  plastic  and  outer  :  plastic)  of</option>

        </datalist> 
      </div>
      )
    }else{
      return (<div>
        {/* <Form.Control as="select" onChange={(e) => { this.handleDescription(e) }} id="PackingType1" defaultValue={PackingType} list="brow"> */}
          <input className='form-control' onChange={(e) => { func(e,desIndex) }} id="PackingType1" defaultValue={this.getDefaultValue(PackingType)} list="brow" />
        {/* </Form.Control> */}
        <datalist id="brow">
          <option value="">โปรดเลือก</option>
          <option label='' value="in  new  single  polypropylene  bags  of">in  new  single  polypropylene  bags  of</option>
          <option label='' value="in  new  single  jumbo  polypropylene  bags  of">in  new  single  jumbo  polypropylene  bags  of</option>
          <option label='' value="in  polypropylene  bags  contained  in  polypropylene  of">in  polypropylene  bags  contained  in  polypropylene  of</option>
          <option label='' value="in  double  bags  (inner  :  plastic  and  outer  :  polypropylene)  of">in  double  bags (inner  :  plastic  and  outer  :  polypropylene)  of</option>
          <option label='' value="in  plastic  bags  contained  in  cartons  of">in  plastic  bags  contained  in  cartons  of</option>
          <option label='' value="in  bulk">in  bulk</option>

          <option label='' value="in  new  single  gunny  bags  of">in  new  single  gunny  bags  of</option>
          <option label='' value="in  new  double  polypropylene  bags  of">in  new  double  polypropylene  bags  of</option>
          <option label='' value="in  new  double  gunny  bags  of">in  new  double  gunny  bags  of</option>
          <option label='' value="in  new  triple  polypropylene  bags  of">in  new  triple  polypropylene  bags  of</option>
          <option label='' value="in  polypropylene  with  handle  bags  of">in  polypropylene  with  handle  bags  of</option>
          <option label='' value="in  double  bags  (inner  :  foil  and  outer  :  polypropylene)  of">in  double  bags  (inner  :  foil  and  outer  :  polypropylene) of</option>
          <option label='' value="in  double  bags  (inner  :  plastic  and  outer  :  handle  polypropylene)  of">in  double  bags  (inner  :  plastic  and  outer  :  handle  polypropylene)  of</option>
          <option label='' value="in  plastic  bottle  contained  in  cartons  of">in  plastic  bottle  contained  in  cartons  of</option>
          <option label='' value="in  plastic  bags  contained  in  tray  of">in  plastic  bags  contained  in  tray  of</option>
          <option label='' value="in  double  bags  (inner  :  plastic  and  outer  :  gunny)  of">in  double  bags  (inner  :  plastic  and  outer  :  gunny)  of</option>
          <option label='' value="in  new  single  polyethylene  bags  of">in  new  single  polyethylene  bags  of</option>
          <option label='' value="in  double  bags  (inner  :  plastic  and  outer  :  plastic)  of">in  double  bags  (inner  :  plastic  and  outer  :  plastic)  of</option>

        </datalist> 
      </div>
      )
    }

    // } else {
    //   return <Form.Control id="PackingType1" onChange={(e) => { this.handleDescription(e) }} value={PackingType} />
    // }
  }
  getRiceEN(traffic, newTraffic, idx) {
    if (newTraffic && traffic) {
      traffic = traffic.trim()
      // console.log(traffic)
      //WhiteBrokenRiceA1Super
      let a = { "0": { "trafficType": "1006.30.30-003", "des": "", "riceEN": "WhiteGlutinousRice10" }, "1": { "trafficType": "1006.20.90-607", "des": "", "riceEN": "BlackCargoRiceSuperbQuality" }, "2": { "trafficType": "1006.30.40-001", "des": "", "riceEN": "ThaiFragrantWhiteRice100" }, "3": { "trafficType": "1006.20.90-613", "des": "", "riceEN": "RedCargoRiceSuperbQuality" }, "4": { "trafficType": "1006.30.99-001", "des": "", "riceEN": "ThaiFragrantWhiteRice100" }, "5": { "trafficType": "1006.20.90-619", "des": "", "riceEN": "BlackGlutinousCargoRiceStandardQuality" }, "6": { "trafficType": "1006.20.90-608", "des": "", "riceEN": "BlackCargoRicePrimeQuality" }, "7": { "trafficType": "1006.20.90-614", "des": "", "riceEN": "RedCargoRicePrimeQuality" }, "8": { "trafficType": "1006.20.90-501", "des": "" }, "9": { "trafficType": "1006.20.90-001", "des": "", "riceEN": "ThaiFragrantCargoRice100" }, "10": { "trafficType": "1006.20.90-606", "des": "", "riceEN": "BlackCargoRicePrimeQuality" }, "11": { "trafficType": "1006.20.90-612", "des": "", "riceEN": "RedCargoRicePrimeQuality" }, "12": { "trafficType": "1006.30.91-002", "des": "" }, "13": { "trafficType": "1006.30.99-018", "des": "", "riceEN": "WhiteRice25" }, "14": { "trafficType": "1006.30.99-012", "des": "", "riceEN": "WhiteRice5" }, "15": { "trafficType": "1006.30.30-006", "des": "" }, "16": { "trafficType": "1006.30.99-007", "des": "" }, "17": { "trafficType": "1006.40.90-006", "des": "WhiteBrokenRiceA1Super","riceEN":"WhiteBrokenRiceA1Super" }, "18": { "trafficType": "1006.40.90-019", "des": "", "riceEN": "WhiteGlutinousBrokenRiceA1" }, "19": { "trafficType": "1006.40.90-602", "des": "", "riceEN": "WhiteGlutinousBrokenRiceAsPerSample" }, "20": { "trafficType": "1006.30.91-001", "des": "", "riceEN": "ParboiledRice100Sorted" }, "21": { "trafficType": "1006.30.91-600", "des": "", "riceEN": "ParboiledRiceAsPerSample" }, "22": { "trafficType": "1006.30.99-013", "des": "", "riceEN": "WhiteRice10" }, "23": { "trafficType": "1006.30.91-003", "des": "", "riceEN": "ParboiledRice5Sorted" }, "24": { "trafficType": "1006.40.90-005", "des": "", "riceEN": "ThaiFragrantWhiteBrokenRiceA1Super" }, "25": { "trafficType": "1006.20.90-018", "des": "", "riceEN": "CargoRice100GradeB" }, "26": { "trafficType": "1006.20.90-616", "des": "" }, "27": { "trafficType": "1006.30.99-010", "des": "", "riceEN": "WhiteRice100B" }, "28": { "trafficType": "1006.30.99-601", "des": "", "riceEN": "WhiteRiceAsPerSample" }, "29": { "trafficType": "1006.40.90-012", "des": "", "riceEN": "ThaiFragrantWhiteBrokenRiceA1Super" }, "30": { "trafficType": "1006.20.90-604", "des": "", "riceEN": "SpecialMixedCargoRiceAsPerSample" }, "31": { "trafficType": "1006.20.90-504", "des": "", "riceEN": "CargoRiceAsPerSample" }, "32": { "trafficType": "1006.20.90-615", "des": "", "riceEN": "RedCargoRiceSuperbQuality" }, "33": { "trafficType": "1006.40.90-010", "des": "", "riceEN": "ThaiFragrantWhiteBrokenRiceA1ExtraSuper" }, "34": { "trafficType": "1006.30.99-003", "des": "", "riceEN": "ThaiFragrantWhiteRice5" }, "35": { "trafficType": "1006.30.99-600", "des": "", "riceEN": "ThaiFragrantWhiteRiceAsPerSample" }, "36": { "trafficType": "1006.20.90-506", "des": "", "riceEN": "ThaiFragrantCargoRice100" }, "37": { "trafficType": "1006.20.90-633", "des": "", "riceEN": "BlackCargoRiceAsPerSample" }, "38": { "trafficType": "1006.30.99-014", "des": "", "riceEN": "WhiteRice15" }, "39": { "trafficType": "1006.20.90-600", "des": "",'riceEN' : 'CargoParboiledRiceAsPerSample' }, "40": { "trafficType": "1006.20.90-601", "des": "", "riceEN": "ThaiFragrantCargoRiceAsPerSample" }, "41": { "trafficType": "1006.30.99-603", "des": "", "riceEN": "SpecialMixedRiceAsPerSample" }, "42": { "trafficType": "1006.20.90-630", "des": "" }, "43": { "trafficType": "1006.20.90-618", "des": "", "riceEN": "BlackGlutinousCargoRiceBestQuality" }, "44": { "trafficType": "1006.40.90-018", "des": "", "riceEN": "ParboiledBrokenRiceA1" }, "45": { "trafficType": "1006.40.90-600", "des": "", "riceEN": "WhiteBrokenRiceC1AsPerSample" }, "46": { "trafficType": "1006.30.30-004", "des": "", "riceEN": "WhiteGlutinousRice10" }, "47": { "trafficType": "1006.40.90-001", "des": "", "riceEN": "CargoBrokenRiceAsPerSample" }, "48": { "trafficType": "1006.20.90-632", "des": "" }, "49": { "trafficType": "1006.30.91-007", "des": "", "riceEN": "ParboiledRice15" }, "50": { "trafficType": "1006.30.91-004", "des": "", "riceEN": "ParboiledRice5" }, "51": { "trafficType": "1006.20.90-010", "des": "", "riceEN": "CargoRice5" }, "52": { "trafficType": "1006.30.99-009", "des": "", "riceEN": "WhiteRice100A" }, "53": { "trafficType": "1006.20.90-609", "des": "", "riceEN": "BlackCargoRiceSuperbQuality" }, "54": { "trafficType": "1006.30.99-015", "des": "" }, "55": { "trafficType": "1006.30.99-502", "des": "", "riceEN": "ThaiFragrantWhiteRice100" }, "56": { "trafficType": "1006.30.40-500", "des": "", "riceEN": "ThaiFragrantWhiteRice100" }, "57": { "trafficType": "1006.40.90-004", "des": "", "riceEN": "WhiteBrokenRiceA1ExtraSuper" }, "58": { "trafficType": "1006.30.99-602", "des": "", "riceEN": "WhiteRiceAsPerSample" }, "59": { "trafficType": "1006.20.90-610", "des": "", "riceEN": "BlackCargoRiceAsPerSample" }, "60": { "trafficType": "1006.20.90-622", "des": "", "riceEN": 'BlackGlutinousCargoRiceAsPerSample' }, "61": { "trafficType": "1006.20.90-631", "des": "" }, "62": { "trafficType": "1006.20.90-605", "des": "", "riceEN": "RedCargoRiceSuperbQuality" }, "63": { "trafficType": "1006.30.30-601", "des": "" }, "64": { "trafficType": "1006.30.99-023", "des": "", "riceEN": "WhiteRiceEnrichedVitaminAsPerSample" }, "65": { "trafficType": "1006.30.40-006", "des": "", "riceEN": "ThaiFragrantWhiteRice15" }, "66": { "trafficType": "1006.40.90-003", "des": "" }, "67": { "trafficType": "1006.30.99-022", "des": "", "riceEN": "WhiteRice45" }, "68": { "trafficType": "1006.30.99-011", "des": "", "riceEN": "WhiteRice100C" }, "69": { "trafficType": "1006.30.99-005", "des": "" }, "70": { "trafficType": "1006.20.90-011", "des": "", "riceEN": "CargoRice10" }, "71": { "trafficType": "1006.40.90-609", "des": "" }, "72": { "trafficType": "1006.20.90-012", "des": "" }, "73": { "trafficType": "1006.20.90-508", "des": "" }, "74": { "trafficType": "1006.20.90-611", "des": "" }, "75": { "trafficType": "1006.20.90-617", "des": "" }, "76": { "trafficType": "1006.20.90-620", "des": "", "riceEN": "BlackGlutinousCargoRiceBestQuality" } }
      let arr = Object.values(newTraffic).filter((dataFilter) => {
        return dataFilter['riceID'] == traffic
      })
      if (arr.length == 0) {
        let output = traffic
        // console.log(output)
        Object.values(a).map((data) => {
          if (data['trafficType'] == traffic) {
            output = data['riceEN']
          }
        }) 
        if (idx == 1) {
          return output
        } else {
          return ''
        }
      } else {
        let data = arr[0]
        // console.log(data)
        if (idx == 1) {
          // console.log(data['wtf'])
          // console.log(this.convertDeCodeText(data['wtf']))
          return this.convertDeCodeText(data['wtf'])
        } else if (idx == 2) {
          return this.convertDeCodeText(data['wtf2'])
        } else if (idx == 3) {
          return this.convertDeCodeText(data['wtf3'])
        }

      }
    }

  }
  render() {
    let CheckWeightSheet = this.state.Certificate
    // console.log(CheckWeightSheet.description[this.props.desIndex])
    // console.log(CheckWeightSheet.checkWeightDescription[this.props.desIndex])
    let pointOn = 'online'
    if (this.props.CertificateSheetDataOnline) {
      // if ( false) {

      let handleData = this.props.CertificateSheetDataOnline.Certificate.description[this.props.desIndex]
      CheckWeightSheet = this.props.CertificateSheetDataOnline.Certificate
      
      console.log(this.props.CertificateSheetDataOnline)

      handleData['unique'] = handleData['riceTypeID']
      handleData['wtf1'] = handleData['wtf1'] || convertRiceTypeENToENFull(this.getRiceEN(handleData['riceTypeID'], this.props.fullNameRiceAsSample, 1))
      handleData['wtf2'] = handleData['wtf2'] == undefined ? convertRiceTypeENToENFull(this.getRiceEN(handleData['riceTypeID'], this.props.fullNameRiceAsSample, 2)) : handleData['wtf2']
      if(handleData['wtf3'] == ''){
        handleData['wtf3'] = ''
      }else{
        handleData['wtf3'] = handleData['wtf3'] || convertRiceTypeENToENFull(this.getRiceEN(handleData['riceTypeID'], this.props.fullNameRiceAsSample, 3))

      }

      return (
        <div>

          <div style={{ width: '100%', alignContent: 'center', textAlign: 'center', fontSize: '22px' }}  >
            <p><b><u>Quality and Weight Certificate</u></b></p>
          </div>
          {
            <div>
              <div className='TopSpace'>
                <Row>
                  <Col align="center">
                    <Form className='ScaleDown'>
                      <Form.Group className="FormGroup" as={Row} controlId="Date">
                        <Form.Label column sm="3">
                          No :
                      </Form.Label>
                        <Col sm="3">
                          <Form.Control id="No" onChange={(e) => { this.props.handleDescription(e, this.props.desIndex) }} value={handleData['No']} />
                          {/* {console.log(CheckWeightSheet['companyEN'])} */}
                        </Col>
                        <Form.Label column sm="2">
                          Date :
                      </Form.Label>
                        <Col sm="3">
                          <Form.Control id="currentDate" onChange={(e) => { this.props.handleCertificate(e) }} value={CheckWeightSheet['currentDate']} />
                          {/* {console.log(CheckWeightSheet['companyEN'])} */}
                        </Col>

                      </Form.Group>
                      <Form.Group className="FormGroup" as={Row} controlId="title">
                        <Form.Label column sm="3">
                          Title :
                      </Form.Label>
                        <Col sm="8">
                          <Form.Control id="title1" onChange={(e) => { this.props.handleCertificate(e) }} value={CheckWeightSheet['title1']} />
                          {/* {console.log(CheckWeightSheet['companyEN'])} */}
                        </Col>
                      </Form.Group>
                      <Form.Group as={Row} controlId="bagQuantity">
                        <Form.Label column sm="3">
                          Quantity :
                      </Form.Label>
                        <Col sm="8">
                          <Form.Control id="bagQuantity" onChange={(e) => { this.props.handleDescription(e, this.props.desIndex) }} value={handleData['bagQuantity']} />
                        </Col>
                      </Form.Group>

                      <Form.Group as={Row} controlId="riceTypeID">
                        <Form.Label column sm="3">
                          Description of goods (1):
                        </Form.Label>
                        <Col sm="8">
                          {console.log(handleData)}
                          <Form.Control id="wtf1" onChange={(e) => { this.props.handleDescription(e, this.props.desIndex) }} value={handleData['wtf1']} />
                        </Col>
                      </Form.Group>
                      <Form.Group as={Row} controlId="riceTypeID2">
                        <Form.Label column sm="3">
                          Description of goods (1.1):
                      </Form.Label>
                        <Col sm="8">
                          <Form.Control id="wtf2" onChange={(e) => { this.props.handleDescription(e, this.props.desIndex) }} value={handleData['wtf2']} />
                        </Col>
                      </Form.Group>
                      <Form.Group as={Row} controlId="riceTypeID3">
                        <Form.Label column sm="3">
                          Description of goods (1.2):
                      </Form.Label>
                        <Col sm="8">
                          <Form.Control id="wtf3" onChange={(e) => { this.props.handleDescription(e, this.props.desIndex) }} value={handleData['wtf3']} />
                        </Col>
                      </Form.Group>
                      {/* 
                      <Form.Group as={Row} controlId="riceTypeID">
                        <Form.Label column sm="3">
                          Description of goods :
                      </Form.Label>
                        <Col sm="8">
                          <Form.Control id="riceTypeID" onChange={(e) => { this.props.handleDescription(e, this.props.desIndex) }} value={handleData['riceTypeName']} />
                        </Col>
                      </Form.Group> */}
                      <Form.Group as={Row} controlId="PackingType1">
                        <Form.Label column sm="3">
                          Packing (1) :
                      </Form.Label>
                        <Col sm="8"> 
                          {/* {console.log(CheckWeightSheet.description[this.props.desIndex])} */}
                          {/* {console.log(CheckWeightSheet)} */}
 
                          {this.renderPackingType(handleData['PackingType1'],this.props.handleDescription,this.props.desIndex)}
                          {/* <Form.Control id="PackingType1" onChange={(e) => { this.props.handleDescription(e, this.props.desIndex) }} value={handleData['PackingType1']} /> */}


                        </Col>
                      </Form.Group>
                      <Form.Group as={Row} controlId="PackingType11">
                        <Form.Label column sm="3">
                          Packing (1.1) :
                      </Form.Label>
                        <Col sm="8">
                          {/* {console.log(CheckWeightSheet.description[this.props.desIndex])} */}
                          {/* {console.log(CheckWeightSheet)} */}
                          <Form.Control id="PackingType11" onChange={(e) => { this.props.handleDescription(e, this.props.desIndex) }} value={handleData['PackingType11']} />
                        </Col>
                      </Form.Group>
                      <Form.Group as={Row} controlId="PackingType12">
                        <Form.Label column sm="3">
                          Packing (1.2) :
                      </Form.Label>
                        <Col sm="8">
                          {/* {console.log(CheckWeightSheet.description[this.props.desIndex])} */}
                          {/* {console.log(CheckWeightSheet)} */}
                          <Form.Control id="PackingType12" onChange={(e) => { this.props.handleDescription(e, this.props.desIndex) }} value={handleData['PackingType12']} />
                        </Col>
                      </Form.Group>

                      <Form.Group as={Row} controlId="PackingType2">
                        <Form.Label column sm="3">
                          Packing (2) :
                      </Form.Label>
                        <Col sm="8">
                          <Form.Control id="PackingType2" onChange={(e) => { this.props.handleDescription(e, this.props.desIndex) }} value={handleData['PackingType2']} />
                        </Col>
                      </Form.Group>
                      <Form.Group as={Row} controlId="logo">
                        <Form.Label column sm="3">
                          Mask :
                      </Form.Label>
                        <Col sm="8">
                          {/* {console.log(CheckWeightSheet.description[this.props.desIndex])} */}
                          {/* {console.log(CheckWeightSheet)} */}
                          <Form.Control id="logo" onChange={(e) => { this.props.handleDescription(e, this.props.desIndex) }} value={handleData['logo']} />
                        </Col>
                      </Form.Group>
                      <Form.Group as={Row} controlId="companyEN">
                        <Form.Label column sm="3">
                          Shipper :
                      </Form.Label>
                        <Col sm="8">
                          {/* {console.log(CheckWeightSheet.description[this.props.desIndex])} */}
                          {/* {console.log(CheckWeightSheet)} */}
                          <Form.Control id="companyEN" onChange={(e) => { this.props.handleCertificate(e) }} value={CheckWeightSheet['companyEN']} />
                        </Col>
                      </Form.Group>
                      <Form.Group as={Row} controlId="ShipperBehalf">
                        <Form.Label column sm="3">
                          Shipper on behalf of:
                      </Form.Label>
                        <Col sm="8">
                          {/* {console.log(CheckWeightSheet.description[this.props.desIndex])} */}
                          {/* {console.log(CheckWeightSheet)} */}

                          <Form.Control id="ShipperBehalf" onChange={(e) => { this.props.handleDescription(e, this.props.desIndex) }} value={handleData['ShipperBehalf']} />
                        </Col>
                      </Form.Group>
                      <Form.Group as={Row} controlId="shippingDate">
                        <Form.Label column sm="3">
                          Date of Loading :
                      </Form.Label>
                        <Col sm="8">
                          {/* {console.log(CheckWeightSheet.description[this.props.desIndex])} */}
                          {console.log(CheckWeightSheet)}

                          <Form.Control id="shippingDate" onChange={(e) => { this.props.handleCertificate(e) }} value={CheckWeightSheet['shippingDate']} />
                        </Col>
                      </Form.Group>
                      <Form.Group as={Row} controlId="godown">
                        <Form.Label column sm="3">
                          Place of Loading :
                      </Form.Label>
                        <Col sm="8">
                          {/* {console.log(CheckWeightSheet.description[this.props.desIndex])} */}
                          {/* {console.log(CheckWeightSheet)} */}

                          <Form.Control id="godown" onChange={(e) => { this.props.handleCertificate(e) }} value={CheckWeightSheet['godown']} />
                        </Col>
                      </Form.Group>
                      <Form.Group as={Row} controlId="shippingPort">
                        <Form.Label column sm="3">
                          Shipping port :
                      </Form.Label>
                        <Col sm="8">
                          {/* {console.log(CheckWeightSheet.description[this.props.desIndex])} */}
                          {/* {console.log(CheckWeightSheet)} */}

                          <Form.Control id="shippingPort" onChange={(e) => { this.props.handleCertificate(e) }} value={CheckWeightSheet['shippingPort']} />
                        </Col>
                      </Form.Group>
                      <Form.Group as={Row} controlId="vehicleName">
                        <Form.Label column sm="3">
                          Carrying vessel :
                      </Form.Label>
                        <Col sm="8">
                          {/* {console.log(CheckWeightSheet.description[this.props.desIndex])} */}
                          {/* {console.log(CheckWeightSheet)} */}
                          <Form.Control id="vehicleName" onChange={(e) => { this.props.handleDescription(e, this.props.desIndex) }} value={handleData['vehicleName']} />
                        </Col>
                      </Form.Group>

                      <Form.Group as={Row} controlId="destinationCity">
                        <Form.Label column sm="3">
                          Destination :
                        </Form.Label>
                        <Col sm="8">

                          <Form.Control id="destinationCity" onChange={(e) => { this.props.handleDescription(e, this.props.desIndex) }} value={handleData['destinationCity']} />
                        </Col>
                      </Form.Group>

                      <Form.Group as={Row} controlId="Quality1">
                        <Form.Label column sm="3">
                          Quality (1) :
                        </Form.Label>
                        <Col sm="8">

                          <Form.Control id="Quality1" onChange={(e) => { this.props.handleCertificate(e) }} value={CheckWeightSheet['Quality1']} />
                        </Col>
                      </Form.Group>
                      <Form.Group as={Row} controlId="Quality2">
                        <Form.Label column sm="3">
                          Quality (2) :
                        </Form.Label>
                        <Col sm="8">

                          <Form.Control id="Quality2" onChange={(e) => { this.props.handleCertificate(e) }} value={CheckWeightSheet['Quality2']} />
                        </Col>
                      </Form.Group>

                      <Form.Group as={Row} controlId="Weight">
                        <Form.Label column sm="3">
                          Weight :
                        </Form.Label>
                        <Col sm="8">

                          <Form.Control id="Weight" onChange={(e) => { this.props.handleCertificate(e) }} value={CheckWeightSheet['Weight']} />
                        </Col>
                      </Form.Group>

                      <Form.Group as={Row} controlId="TotalGross">
                        <Form.Label column sm="3">
                          Total gross :
                        </Form.Label>
                        <Col sm="8">

                          <Form.Control id="TotalGross" onChange={(e) => { this.props.handleDescription(e, this.props.desIndex) }} value={handleData['TotalGross']} />
                        </Col>
                      </Form.Group>

                      <Form.Group as={Row} controlId="TotalTare">
                        <Form.Label column sm="3">
                          Total tare :
                        </Form.Label>
                        <Col sm="8">
                          {console.log(handleData)}
                          <Form.Control id="TotalTare" onChange={(e) => { this.props.handleDescription(e, this.props.desIndex) }} value={handleData['TotalTare']} />
                        </Col>
                      </Form.Group>

                      <Form.Group as={Row} controlId="TotalNett">
                        <Form.Label column sm="3">
                          Total nett :
                        </Form.Label>
                        <Col sm="8">
                          <Form.Control id="TotalNett" onChange={(e) => { this.props.handleDescription(e, this.props.desIndex) }} value={handleData['TotalNett']} />
                        </Col>
                      </Form.Group>

                      <Form.Group as={Row} controlId="License">
                        <Form.Label column sm="3">
                          Export license No :
                        </Form.Label>
                        <Col sm="8">
                          <Form.Control id="License" onChange={(e) => { this.props.handleDescription(e, this.props.desIndex) }} value={handleData['License']} />
                        </Col>
                      </Form.Group>
                    </Form> 
                    {/* {console.log(`minus in order = ${this.props.minusHeight}`)} */}
                    <Button onClick={() => { this.props.printOut(this.props.desIndex, this.props.CertificateSheetDataOnline.Certificate,this.props.minusHeight , this.props.minusCurrentDate,this.props.minusCertNo) }}>ปริ้นเอกสาร</Button>
                  &nbsp;&nbsp;&nbsp;
                  <Button onClick={() => { this.props.createCertificate(this.props.desIndex, this.props.CertificateSheetDataOnline.Certificate) }}>บันทึกและดาวน์โหลด</Button>
                  &nbsp;&nbsp;&nbsp;
                  <Button onClick={() => { this.props.saveCertificate(this.props.desIndex, this.props.CertificateSheetDataOnline.Certificate) }}>บันทึกในระบบ</Button>
 

                    {/* <h1>Job order NO : {CheckWeightSheet.requestID}<br /><br /></h1><h3>
                    <Badge variant="primary">License No :<br />{CheckWeightSheet.description[this.props.desIndex].licenseID} / {parseInt(CheckWeightSheet.description[this.props.desIndex].subID) + 1}</Badge></h3><br /> */}
                  </Col>
                </Row>
              </div>
            </div>
          }
        </div>
      )
    }
    else if (CheckWeightSheet) {
      let handleData = CheckWeightSheet.description[this.props.desIndex]
      // console.log()
      // console.log(handleData['wtf'])
      // console.log(this.getRiceEN(handleData['wtf'], 1))
      // console.log(handleData['riceTypeID'])
      // console.log(this.getRiceEN(handleData['riceTypeID'], this.props.fullNameRiceAsSample, 1))
      handleData['unique'] = handleData['riceTypeID']
      // console.log(convertRiceTypeENToENFull(this.getRiceEN(handleData['riceTypeID'], this.props.fullNameRiceAsSample, 1)))
      handleData['wtf1'] = handleData['wtf1'] || convertRiceTypeENToENFull(this.getRiceEN(handleData['riceTypeID'], this.props.fullNameRiceAsSample, 1))
      handleData['wtf2'] = handleData['wtf2'] == undefined ? convertRiceTypeENToENFull(this.getRiceEN(handleData['riceTypeID'], this.props.fullNameRiceAsSample, 2)) : handleData['wtf2']

      // console.log(handleData['wtf3'])
      // console.log(convertRiceTypeENToENFull(this.getRiceEN(handleData['riceTypeID'], this.props.fullNameRiceAsSample, 3)))
      if(handleData['wtf3'] == ''){
        handleData['wtf3'] = ''
      }else{
        handleData['wtf3'] = handleData['wtf3'] || convertRiceTypeENToENFull(this.getRiceEN(handleData['riceTypeID'], this.props.fullNameRiceAsSample, 3))
      }
      return (
        <div>
          <div style={{ width: '100%', alignContent: 'center', textAlign: 'center', fontSize: '22px' }}  >
            <p><b><u>Quality and Weight Certificate </u></b></p>
          </div>
          {
            <div>
              <div className='TopSpace'>
                <Row>
                  <Col align="center">
                    <Form className='ScaleDown'>
                      <Form.Group className="FormGroup" as={Row} controlId="Date">
                        <Form.Label column sm="3">
                          No :
                      </Form.Label>
                        <Col sm="3">
                          <Form.Control id="No" onChange={(e) => { this.handleDescription(e) }} value={handleData['No']} />
                          {/* {console.log(CheckWeightSheet['companyEN'])} */}
                        </Col>
                        <Form.Label column sm="2">
                          Date :
                      </Form.Label>
                        <Col sm="3">
                          <Form.Control id="currentDate" onChange={(e) => { this.handleCertificate(e) }} value={CheckWeightSheet['currentDate']} />
                          {/* {console.log(CheckWeightSheet['companyEN'])} */}
                        </Col>

                      </Form.Group>
                      <Form.Group className="FormGroup" as={Row} controlId="title">
                        <Form.Label column sm="3">
                          Title :
                      </Form.Label>
                        <Col sm="8">
                          <Form.Control id="title1" onChange={(e) => { this.handleCertificate(e) }} value={CheckWeightSheet['title1']} />
                          {/* {console.log(CheckWeightSheet['companyEN'])} */}
                        </Col>
                      </Form.Group>
                      <Form.Group as={Row} controlId="bagQuantity">
                        <Form.Label column sm="3">
                          Quantity :
                      </Form.Label>
                        <Col sm="8">
                          <Form.Control id="bagQuantity" onChange={(e) => { this.handleDescription(e) }} value={handleData['bagQuantity']} />
                        </Col>
                      </Form.Group>
                      {/* {console.log(handleData)} */}
                      <Form.Group as={Row} controlId="riceTypeID">
                        <Form.Label column sm="3">
                          Description of goods (1):
                        </Form.Label>
                        <Col sm="8">
                          <Form.Control id="wtf1" onChange={(e) => { this.handleDescription(e) }} value={handleData['wtf1']} />
                        </Col>
                      </Form.Group>
                      <Form.Group as={Row} controlId="riceTypeID2">
                        <Form.Label column sm="3">
                          Description of goods (1.1):
                      </Form.Label>
                        <Col sm="8">
                          <Form.Control id="wtf2" onChange={(e) => { this.handleDescription(e) }} value={handleData['wtf2']} />
                        </Col>
                      </Form.Group>
                      <Form.Group as={Row} controlId="riceTypeID3">
                        <Form.Label column sm="3">
                          Description of goods (1.2):
                      </Form.Label>
                        <Col sm="8">
                          <Form.Control id="wtf3" onChange={(e) => { this.handleDescription(e) }} value={handleData['wtf3']} />
                        </Col>
                      </Form.Group>



                      <Form.Group as={Row} controlId="PackingType1">
                        <Form.Label column sm="3">
                          Packing (1) :
                      </Form.Label>
                        <Col sm="8">
                          {this.renderPackingType(handleData['PackingType1'])}
                        </Col>
                      </Form.Group>
                      <Form.Group as={Row} controlId="PackingType11">
                        <Form.Label column sm="3">
                          Packing (1.1) :
                      </Form.Label>
                        <Col sm="8">
                          {/* {console.log(CheckWeightSheet.description[this.props.desIndex])} */}
                          {/* {console.log(CheckWeightSheet)} */}
                          <Form.Control id="PackingType11" onChange={(e) => { this.handleDescription(e) }} value={handleData['PackingType11']} />
                        </Col>
                      </Form.Group>
                      <Form.Group as={Row} controlId="PackingType12">
                        <Form.Label column sm="3">
                          Packing (1.2) :
                      </Form.Label>
                        <Col sm="8">
                          {/* {console.log(CheckWeightSheet.description[this.props.desIndex])} */}
                          {/* {console.log(CheckWeightSheet)} */}
                          <Form.Control id="PackingType12" onChange={(e) => { this.handleDescription(e) }} value={handleData['PackingType12']} />
                        </Col>
                      </Form.Group>

                      <Form.Group as={Row} controlId="PackingType2">
                        <Form.Label column sm="3">
                          Packing (2) :
                      </Form.Label>
                        <Col sm="8">
                          <Form.Control id="PackingType2" onChange={(e) => { this.handleDescription(e) }} value={handleData['PackingType2']} />
                        </Col>
                      </Form.Group>
                      <Form.Group as={Row} controlId="logo">
                        <Form.Label column sm="3">
                          Mask :
                      </Form.Label>
                        <Col sm="8">
                          {/* {console.log(CheckWeightSheet.description[this.props.desIndex])} */}
                          {/* {console.log(CheckWeightSheet)} */}
                          <Form.Control id="logo" onChange={(e) => { this.handleDescription(e) }} value={handleData['logo']} />
                        </Col>
                      </Form.Group>
                      <Form.Group as={Row} controlId="companyEN">
                        <Form.Label column sm="3">
                          Shipper :
                      </Form.Label>
                        <Col sm="8">
                          {/* {console.log(CheckWeightSheet.description[this.props.desIndex])} */}
                          {/* {console.log(CheckWeightSheet)} */}
                          <Form.Control id="companyEN" onChange={(e) => { this.handleCertificate(e) }} value={CheckWeightSheet['companyEN']} />
                        </Col>
                      </Form.Group>
                      <Form.Group as={Row} controlId="ShipperBehalf">
                        <Form.Label column sm="3">
                          Shipper on behalf of:
                      </Form.Label>
                        <Col sm="8">
                          {/* {console.log(CheckWeightSheet.description[this.props.desIndex])} */}
                          {/* {console.log(CheckWeightSheet)} */}

                          <Form.Control id="ShipperBehalf" onChange={(e) => { this.handleDescription(e) }} value={handleData['ShipperBehalf']} />
                        </Col>
                      </Form.Group>
                      <Form.Group as={Row} controlId="shippingDate">
                        <Form.Label column sm="3">
                          Date of Loading :
                      </Form.Label>
                        <Col sm="8">
                          {/* {console.log(CheckWeightSheet.description[this.props.desIndex])} */}
                          {/* {console.log(CheckWeightSheet)} */}

                          <Form.Control id="shippingDate" onChange={(e) => { this.handleCertificate(e) }} value={CheckWeightSheet['shippingDate']} />
                        </Col>
                      </Form.Group>
                      <Form.Group as={Row} controlId="godown">
                        <Form.Label column sm="3">
                          Place of Loading :
                      </Form.Label>
                        <Col sm="8">
                          {/* {console.log(CheckWeightSheet.description[this.props.desIndex])} */}
                          {/* {console.log(CheckWeightSheet)} */}

                          <Form.Control id="godown" onChange={(e) => { this.handleCertificate(e) }} value={CheckWeightSheet['godown']} />
                        </Col>
                      </Form.Group>
                      <Form.Group as={Row} controlId="shippingPort">
                        <Form.Label column sm="3">
                          Shipping port :
                      </Form.Label>
                        <Col sm="8">
                          {/* {console.log(CheckWeightSheet.description[this.props.desIndex])} */}
                          {/* {console.log(CheckWeightSheet)} */}

                          <Form.Control id="shippingPort" onChange={(e) => { this.handleCertificate(e) }} value={CheckWeightSheet['shippingPort']} />
                        </Col>
                      </Form.Group>
                      <Form.Group as={Row} controlId="vehicleName">
                        <Form.Label column sm="3">
                          Carrying vessel :
                      </Form.Label>
                        <Col sm="8">
                          {/* {console.log(CheckWeightSheet.description[this.props.desIndex])} */}
                          {/* {console.log(CheckWeightSheet)} */}
                          <Form.Control id="vehicleName" onChange={(e) => { this.handleDescription(e) }} value={handleData['vehicleName']} />
                        </Col>
                      </Form.Group>

                      <Form.Group as={Row} controlId="destinationCity">
                        <Form.Label column sm="3">
                          Destination :
                        </Form.Label>
                        <Col sm="8">

                          <Form.Control id="destinationCity" onChange={(e) => { this.handleDescription(e) }} value={handleData['destinationCity']} />
                        </Col>
                      </Form.Group>

                      <Form.Group as={Row} controlId="Quality1">
                        <Form.Label column sm="3">
                          Quality (1) :
                        </Form.Label>
                        <Col sm="8">

                          <Form.Control id="Quality1" onChange={(e) => { this.handleCertificate(e) }} value={CheckWeightSheet['Quality1']} />
                        </Col>
                      </Form.Group>
                      <Form.Group as={Row} controlId="Quality2">
                        <Form.Label column sm="3">
                          Quality (2) :
                        </Form.Label>
                        <Col sm="8">

                          <Form.Control id="Quality2" onChange={(e) => { this.handleCertificate(e) }} value={CheckWeightSheet['Quality2']} />
                        </Col>
                      </Form.Group>

                      <Form.Group as={Row} controlId="Weight">
                        <Form.Label column sm="3">
                          Weight :
                        </Form.Label>
                        <Col sm="8">

                          <Form.Control id="Weight" onChange={(e) => { this.handleCertificate(e) }} value={CheckWeightSheet['Weight']} />
                        </Col>
                      </Form.Group>

                      <Form.Group as={Row} controlId="TotalGross">
                        <Form.Label column sm="3">
                          Total gross :
                        </Form.Label>
                        <Col sm="8">

                          <Form.Control id="TotalGross" onChange={(e) => { this.handleDescription(e) }} value={handleData[`TotalGross`]} />
                        </Col>
                      </Form.Group>

                      <Form.Group as={Row} controlId="TotalTare">
                        <Form.Label column sm="3">
                          Total tare :
                        </Form.Label>
                        <Col sm="8">
                          <Form.Control id="TotalTare" onChange={(e) => { this.handleDescription(e) }} value={handleData['TotalTare']} />
                        </Col>
                      </Form.Group>

                      <Form.Group as={Row} controlId="TotalNett">
                        <Form.Label column sm="3">
                          Total nett :
                        </Form.Label>
                        <Col sm="8">
                          <Form.Control id="TotalNett" onChange={(e) => { this.handleDescription(e) }} value={handleData['TotalNett']} />
                        </Col>
                      </Form.Group>

                      <Form.Group as={Row} controlId="License">
                        <Form.Label column sm="3">
                          Export license No :
                        </Form.Label>
                        <Col sm="8">
                          <Form.Control id="License" onChange={(e) => { this.handleDescription(e) }} value={handleData['License']} />
                        </Col>
                      </Form.Group>

                    </Form>
                    <Button onClick={() => { this.props.printOut(this.props.desIndex, CheckWeightSheet,this.props.minusHeight,this.props.minusCurrentDate,this.props.minusCertNo) }}>ปริ้นเอกสาร</Button>
                  &nbsp;&nbsp;&nbsp;
                  <Button onClick={() => { this.props.createCertificate(this.props.desIndex, this.state.Certificate) }}>บันทึกและดาวน์โหลด</Button>
                  &nbsp;&nbsp;&nbsp;
                  <Button onClick={() => { this.props.saveCertificate(this.props.desIndex, this.state.Certificate) }}>บันทึกในระบบ</Button>

                    {/* <h1>Job order NO : {CheckWeightSheet.requestID}<br /><br /></h1><h3>
                    <Badge variant="primary">License No :<br />{CheckWeightSheet.description[this.props.desIndex].licenseID} / {parseInt(CheckWeightSheet.description[this.props.desIndex].subID) + 1}</Badge></h3><br /> */}
                  </Col>
                </Row>
              </div>
            </div>
          }
        </div>
      )
    }

    else { return <div></div> }
  }
}

